module.exports = __webpack_public_path__ + "img/palmas-pool-4.d9f1057f.jpg";